import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Artikel } from '../../../store/models/artikel';

@Component({
    selector: 'kkis-app-webshop-filter-chips',
    templateUrl: './filter-chips.component.html',
    styleUrls: ['./filter-chips.component.scss']
})
export class FilterChipsComponent implements OnInit, OnChanges {

    // Input
    @Input()
    filterMerkmale: string;

    @Input()
    merkmalGruppen: Artikel.IMerkmalGruppeDto[];

    @Output()
    filterRemoved: EventEmitter<Artikel.IMerkmalDto> = new EventEmitter<Artikel.IMerkmalDto>();

    // Filter:Größe + Farbe + Merkmale
    _filterGroessen: string[] = [];
    _filterFarben: string[] = [];
    _filterMerkmale: number[] = [];

    filterGroesse: string[] = [];
    filterFarbe: string[] = [];
    filterMerkmal: number[] = [];

    selectedFilters: Artikel.IMerkmalDto[];
    
    // Utils
    isLoading: boolean = false;
    isMerkmalGruppenAvailable: boolean = false;
    visible: boolean = true;
    selectable: boolean = true;
    removable: boolean = true;
    addOnBlur = true;

    constructor() { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {

        // if (changes.category != null && changes.category.currentValue != null && changes.category.currentValue != changes.category.previousValue) {
        //     this.category = changes.category.currentValue;

        //     this.isCategoryFilter = true;
        // }

        // if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
        //     this.minPreis = changes.minPreis.currentValue;
        // }

        // if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
        //     this.maxPreis = changes.maxPreis.currentValue;
        // }

        // if (changes.groessen != null && changes.groessen.currentValue != null && changes.groessen.previousValue != changes.groessen.currentValue) {
        //     this.groessen = changes.groessen.currentValue;

        //     if (this.groessen.length > 0) {
        //         this.isGroessenAvailable = true;
        //     } else {
        //         this.isGroessenAvailable = false;
        //     }
        // }
        
        // if (changes.farben != null && changes.farben.currentValue != null && changes.farben.previousValue != changes.farben.currentValue) {
        //     this.farben = changes.farben.currentValue;
        //     if (this.farben.length > 0) {
        //         this.isFarbenAvailable = true;
        //     } else {
        //         this.isFarbenAvailable = false;
        //     }
        // }

        // if (changes.filterGroessen != null && changes.filterGroessen.previousValue != changes.filterGroessen.currentValue) {
        //     this.filterGroessen = changes.filterGroessen.currentValue;
            
        //     if(this.filterGroessen)
        //         this._filterGroessen = JSON.parse(this.filterGroessen);
        //     else
        //         this._filterGroessen=[];
        // }

        // if (changes.filterFarben != null  && changes.filterFarben.previousValue != changes.filterFarben.currentValue) {
        //     this.filterFarben = changes.filterFarben.currentValue;
        //     if(this.filterFarben)
        //         this._filterFarben = JSON.parse(this.filterFarben);
        //     else
        //         this._filterFarben=[];
            
        // }

        if (changes.filterMerkmale != null  && changes.filterMerkmale.previousValue != changes.filterMerkmale.currentValue) {
            this.filterMerkmale = changes.filterMerkmale.currentValue;
            if(this.filterMerkmale)
                this._filterMerkmale = JSON.parse(this.filterMerkmale);
            else
                this._filterMerkmale=[];
        }

        if (changes.merkmalGruppen != null && changes.merkmalGruppen.currentValue != null && changes.merkmalGruppen.previousValue != changes.merkmalGruppen.currentValue) {
            this.merkmalGruppen = changes.merkmalGruppen.currentValue;

            if (this.merkmalGruppen.length > 0) {
                this.isMerkmalGruppenAvailable = true;
            } else {
                this.isMerkmalGruppenAvailable = false;
            }
        }

        // this.setGroesse();
        // this.setFarbe();
        this.setMerkmal();

        // this.loadData();
    }



    setMerkmal() {
        this.selectedFilters = [];

        if (this._filterMerkmale && this._filterMerkmale.length > 0) {
            let res: Artikel.IMerkmalDto;

            this._filterMerkmale.forEach(x => {
                if (this.merkmalGruppen) {
                    this.merkmalGruppen.forEach(z => {
                        let idx = z.merkmale.findIndex(y => y.id === x);

                        if (idx > -1) {
                            res = z.merkmale[idx];

                            this.selectedFilters.push(res);

                            if (res) {
                                res.selected = true;
                                z.isActive = true;
                            }
                        }
                    });
                }
            });
        }
    }

    remove(merkmal: Artikel.IMerkmalDto): void {

        console.log("merkmal => ", merkmal);

        const idx = this.selectedFilters.indexOf(merkmal);

        if (idx >= 0) {
            this.selectedFilters.splice(idx, 1);
            this.filterRemoved.emit(merkmal);
        }
    }

}
